.cancelled-icon {
  height: 16px;
  color: var(--default--icon--fill-color--11);
}

.default-icon {
  height: 16px;
  color: var(--default--icon--fill-color--10);
}

.pending-icon {
  height: 16px;
  color: var(--default--icon--fill-color--11);
}

.processed-icon {
  height: 16px;
  color: var(--default--icon--fill-color--11);
}
